module.exports = __webpack_public_path__ + "img/eg9.bce0ffee.png";